// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 任务状态枚举 枚举类
 * 任务状态枚举
 */
export enum EnumTaskStatus {
  /** 未定义 : 未定义 */
  None = 0,
  /** 执行中 : 执行中 */
  Executing = 1,
  /** 已完成 : 已完成 */
  Completed = 2,
  /** 已中断 : 已中断 */
  Terminated = 4,
  /** 发生错误 : 发生错误 */
  AriseError = 8
}

/**
 * 任务状态枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumTaskStatusMD {
  private static items = [
    new EnumItemMD('None', 0, '未定义', '未定义'),
    new EnumItemMD('Executing', 1, '执行中', '执行中'),
    new EnumItemMD('Completed', 2, '已完成', '已完成'),
    new EnumItemMD('Terminated', 4, '已中断', '已中断'),
    new EnumItemMD('AriseError', 8, '发生错误', '发生错误')
  ];

  static getItem(enumItem: EnumTaskStatus) {
    return this.items.find(item => item.name === EnumTaskStatus[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
